/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useCallback, useState } from 'react';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';
import axiosCall from '../../services/axios';
import { getErrorFromEndpoint } from '../../common/UtilityFunctions';

const useAddServicingBatch = () => {
  const { token } = useAuthContext();
  const { get } = useAbortController();
  const [addingBatch, setAddingBatch] = useState(false);
  const [errorAddingBatch, setErrorAddingBatch] = useState('');

  const addServicingBatchAPI = useCallback(
    async (params: AddServicingBatchParams): Promise<UnknownAddServicingBatchResponse> => {
      try {
        if (!token || !params) return null;
        const request = {
          url: process.env.REACT_APP_ADD_SERVICING_BATCH,
          method: 'POST',
          data: params,
        };
        const config = get();
        const headers = {
          'Session-Token': token,
          'Content-Type': 'application/json',
        };
        const response = await axiosCall(request, config, headers);
        const err = getErrorFromEndpoint(response);
        setErrorAddingBatch(err);
        setAddingBatch(false);
        return response;
      } catch (error) {
        setAddingBatch(false);
        setErrorAddingBatch(error);
        return null;
      }
    },
    [get, token],
  );

  const addServicingBatch = useCallback(
    async (params: AddServicingBatchParams): Promise<UnknownAddServicingBatchResponse> => {
      setAddingBatch(true);
      setErrorAddingBatch('');
      const res = await addServicingBatchAPI(params);
      return res;
    },
    [addServicingBatchAPI],
  );

  return {
    addingBatch,
    errorAddingBatch,
    addServicingBatch,
  };
};

export default useAddServicingBatch;
